/**
 * models.js
 */

export const itemTypes = {
  CATEGORY: 'category',
  FILE: 'file'
};


export class CategoryFile {
  constructor(props) {
    const { categoryId, categoryName, fileId, filename, url, file, ...others } = props;
    this.category = {
      id: categoryId,
      name: categoryName,
      localId: categoryId
    };
    this.id = fileId;
    this.localId = fileId;
    this.filename = filename;
    this.url = url;
    this.file = file;

    if (others) {
      Object.assign(this, others);
    }
  }
}


export class CategoryFileList {
  files = [];

  constructor(props) {
    const { id, name, ...others } = props;
    this.id = id;
    this.localId = id;
    this.name = name;

    if (others) {
      Object.assign(this, others);
    }
  }

  addFile(file) {
    if (!file) return;

    const { id: fileId, ...otherFileProps } = file;

    const categoryFile = new CategoryFile({
      categoryId: this.id,
      categoryName: this.name,
      fileId,
      ...otherFileProps
    });

    this.files.push(categoryFile);
  }
}